var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('transition',{attrs:{"name":"fade"}},[(_vm.errorMessageShow)?_c('div',{staticClass:"notification is-danger"},[_c('button',{staticClass:"delete",on:{"click":function($event){return _vm.$emit('close')}}}),_c('p',{domProps:{"innerHTML":_vm._s(_vm.errorMessage)}})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }